import React from 'react';
import {Link} from "react-router-dom";
import config from "../config";
import logoBlack from '../assets/images/logo-black.png';
import {withStyles} from '@material-ui/core/styles';

const BusinessHeaderBare = (props) => {
  const {classes} = props;

  return (
    <div className="row justify-content-center">
      <div className="col-md-12 col-lg-6">
        <Link to={config.routes.business}>
          <img className={classes.logo} src={logoBlack}/>
        </Link>
      </div>
    </div>
  )
};


export default withStyles(theme => ({
  logo: {
    width: '172px',
    margin: '30px 0',
  }
}))(BusinessHeaderBare);


// WEBPACK FOOTER //
// ./src/parts/BusinessHeaderBare.js